import { CPAActionTypes } from './audits';
import { customColors } from './misc';
import { getColor } from '../constants/strings';

export const actionItemTypeIcons = {
  FLEET: {
    icon: 'local_shipping',
    color: 'yellow',
  },
  HR: {
    icon: 'groups',
    color: 'blue',
  },
  INSPECTION: {
    icon: 'search',
    color: 'purple',
  },
  SERVICE: {
    icon: 'build',
    color: 'red',
  },
  HSE: {
    icon: 'health_and_safety',
    color: 'red',
  },
};

export const actionItemIcons = (value, assessmentTypes) => {
  switch (value) {
    case 'vehicle':
      return { icon: 'local_shipping', color: customColors.YELLOW };
    case CPAActionTypes.interim.toLowerCase():
    case CPAActionTypes.final.toLowerCase():
    case CPAActionTypes.review.toLowerCase():
    case CPAActionTypes.accept.toLowerCase():
      return {
        icon: 'error_outlined',
        color: customColors.RED,
        label: 'Corrective',
      };
    case 'incident_comment':
      return { icon: 'fmd_bad', color: 'red' };
    case 'general':
      return { icon: 'task_alt', color: customColors.BLUE_LIGHT };
    default:
      return {
        icon: assessmentTypes[value]?.icon || 'star_border',
        color: getColor(value, assessmentTypes),
      };
  }
};
